{
  "01_Auf-Abgaenge": "Auf-/Abgänge",
  "01_Evakuation": "Evakuierung",
  "01_Gebote_Verbote": "Gebote, Verbote",
  "01_gefahren": "Gefahren Verkehr",
  "01_Gleise": "Gleise",
  "01_Richtungen": "Richtungen",
  "01_Verkehrsmittel": "Verkehrsmittel",
  "010_Basic": "Basis",
  "02_Brandbekaempfung": "Brandbekämpfung",
  "02_Entsorgung_Recycling": "Entsorgung, Recycling",
  "02_Parkieren": "Parkieren",
  "02_Sektoren": "Sektoren",
  "02_verbote": "Verbote Verkehr",
  "020_Arrow": "Pfeile",
  "03_Barrierefreiheit": "Barrierefreiheit",
  "03_gebote": "Gebote Verkehr",
  "03_Hygiene": "Hygiene",
  "03_vorschriftszeichen": "Vorschriftszeichen",
  "04_Dienstleistungen": "Dienstleistungen",
  "04_Funktionsweise": "Funktionsweise",
  "04_Klassen": "Klassen",
  "04_rest": "Rest Verkehr",
  "06_richtzeichen": "Richtzeichen",
  "080_Timetable": "Barrierefreiheit",
  "10_zusatzzeichen": "Zusatzzeichen",
  "110_Location": "Position",
  "190_Installation": "Anlage",
  "ab": "ab",
  "Abbrechen": "Abbrechen",
  "Abmelden": "Abmelden",
  "Absenden": "Absenden",
  "Achtung": "Achtung",
  "admin_settings": "Administrator-Einstellungen",
  "aerial": "Satellit",
  "Aktuelle Zoomstufe": "Aktuelle Zoomstufe",
  "Aktueller Stand des Elements": "Aktueller Stand des Elements",
  "Alle Tags entfernen": "Alle Tags entfernen",
  "already in use for another drawing by this user.": "Name schon in Verwendung.",
  "Als PNG speichern": "Als PNG speichern",
  "Als Standardplan festlegen": "Als Standardplan festlegen",
  "Am rechten Rand andocken": "Am rechten Rand andocken",
  "andere": "andere",
  "Andocken lösen": "Andocken lösen",
  "Änderungen konnten nicht gespeichert werden": "Änderungen konnten nicht gespeichert werden",
  "Änderungen werden gespeichert": "Änderungen werden gespeichert",
  "Anfang Icon": "Anfang Icon",
  "Anfrage versenden": "Anfrage versenden",
  "anfrage_form_success": "Vielen Dank für Ihre Anfrage. Wir werden Sie schnellstmöglich kontaktieren.",
  "Anwenden": "Anwenden",
  "Auf Ausschnitt zentrieren": "Auf Ausschnitt zentrieren",
  "Auf Route zentrieren": "Auf Route zentrieren",
  "Auf Zoomstufen beschränken": "Auf Zoomstufen beschränken",
  "aufgaenge": "Auf- und Abgänge",
  "Auflösung": "Auflösung",
  "Aus": "Aus",
  "Ausgewählte Elemente": "Ausgewählte Elemente",
  "Ausrichtungshilfe": "Ausrichtungshilfe",
  "Ausschnitt festlegen": "Ausschnitt festlegen",
  "Ausschnitt sperren": "Ausschnitt sperren",
  "Ausser Zoomstufen Zoombeschränkung": "Die gewählte Zoombeschränkung befindet sich außerhalb des aktuell sichtbaren Bereichs.",
  "bahnlinien": "Bahnlinien",
  "bahnofplan": "Bahnhofplan",
  "Barrierefreie Route": "Barrierefreie Route",
  "Baselayers": "Hintergrund",
  "basemap": "Netzkarte",
  "Bearbeiten": "Bearbeiten",
  "Benutzeranleitung": "Benutzeranleitung",
  "Betreiber": "Betreiber",
  "bike": "Velo",
  "Bild einfügen": "Bild einfügen",
  "Bild herunterladen": "Bild herunterladen",
  "bis": "bis",
  "Bitte geben Sie einen Plannamen ein.": "Bitte geben Sie einen Plannamen ein.",
  "Bitte loggen Sie sich ein, um die Zeichnung zu exportieren.": "Bitte loggen Sie sich ein, um die Zeichnung zu exportieren.",
  "Bitte, Copyright zu kopieren": "Die zu exportierende Fläche ist zu klein, um das Copyright einzublenden. Bitte vergewissern Sie sich, dass das folgende Copyright in Ihrer Veröffentlichung erscheint:",
  "Branche": "Branche",
  "Bus": "Bus",
  "bus": "Bus",
  "buslinien": "Buslinien",
  "Car": "Auto",
  "car": "Auto",
  "Coach": "Fernbus",
  "coach": "Fernbus",
  "colorful": "Karte farbig",
  "Confirm remove plan": "Sind Sie sicher, dass Sie diesen Plan von Ihrem Profil entfernen möchten",
  "Construction": "Baustelle",
  "Copyright kopiert!": "Copyright kopiert!",
  "custom_layout_dialog_description": "Ihren Plan können Sie direkt in mapset in ein PDF-Template integrieren und exportieren. Die Vorlagen gestalten wir ganz nach Ihren Wünschen bezüglich Format, Logo und Corporate Design sowie Platzierung von Texten und weiteren Elementen. Senden Sie uns eine Nachricht über dieses Formular und wir nehmen mit Ihnen Kontakt auf.",
  "custom_layout_dialog_title": "Eigene PDF-Vorlage erstellen",
  "custom_layout_placeholder_message": "Ich interessiere mich für eine eigene PDF-Vorlage. Bitte kontaktieren Sie mich unter {{user.email}}.",
  "custom_layout_placeholder_title": "mapset-Vorlage für {{user.email}} erstellen",
  "Datenschutz": "Datenschutz",
  "Den bestehenden Plan können sie mit folgendem Link jederzeit weiter bearbeiten.": "Den bestehenden Plan können sie mit folgendem Link jederzeit weiter bearbeiten.",
  "Der aktuelle Anmelde-Status hat sich geändert. Bitte laden Sie die Seite neu.": "Der aktuelle Anmelde-Status hat sich geändert. Bitte laden Sie die Seite neu.",
  "Der geladene Plan ist ein Standardplan. Sie haben keine Rechte, um Standard-Pläne zu bearbeiten.": "Der geladene Plan ist ein Standardplan. Sie haben keine Rechte, um Standard-Pläne zu bearbeiten.",
  "Der Plan wurde geändert": "Der Plan wurde geändert",
  "Dialog nicht mehr anzeigen": "Dialog nicht mehr anzeigen",
  "Did you know?": "Wussten Sie schon?",
  "Die Zeichnung konnte nicht geladen werden.": "Die Zeichnung konnte nicht geladen werden.",
  "Die Zeichnung konnte nicht geladen werden. Bitte kontrollieren Sie Ihre Internet-Verbindung und versuchen Sie es erneut.": "Die Zeichnung konnte nicht geladen werden. Bitte kontrollieren Sie Ihre Internet-Verbindung und versuchen Sie es erneut.",
  "Die zu exportierende Fläche ist zu groß. Die maximal zulässige Größe ist ": "Die zu exportierende Fläche ist zu groß. Die maximal zulässige Größe ist ",
  "Diese Pikto-Gruppe besteht aus": "Diese Pikto-Gruppe besteht aus",
  "Dieser Plan wurde nicht von Ihnen erstellt. Was möchten Sie tun?": "Dieser Plan wurde nicht von Ihnen erstellt. Was möchten Sie tun?",
  "Dieser Plan wurde ursprünglich nicht von Ihnen benannt. Durch Ihre Änderungen wird der Planname für andere User auch aktualisiert.": "Dieser Plan wurde ursprünglich nicht von Ihnen benannt. Durch Ihre Änderungen wird der Planname für andere User auch aktualisiert.",
  "drawinfo.default_for": "Planart",
  "drawinfo.name": "Planname",
  "drawinfo.provider": "Betreiber",
  "drawinfo.station_identifier": "Haltstelle id",
  "drawinfo.station_name": "Haltstelle Name",
  "drawinfo.valid_from": "Gültig von",
  "drawinfo.valid_to": "Gültig bis",
  "drawinfo.viewLinkValidity": "Gültigkeit des Standardplans",
  "Drehung": "Drehung",
  "Dreieck zeichnen": "Dreieck zeichnen",
  "Ebene": "Ebene",
  "Ebenen": "Ebenen",
  "editor_disabled_tooltip_picture": "nur ab Zoomstufe 15 verfügbar",
  "editor_group_area": "Flächen zeichnen",
  "editor_group_line": "Linien zeichnen",
  "editor_group_point": "Punkte zeichnen",
  "Eine Position nach oben": "Nach vorne bringen",
  "Eine Position nach unten": "Nach hinten verschieben",
  "Einloggen": "Einloggen",
  "Einstellungen": "Einstellungen",
  "Element auswählen": "Element auswählen",
  "Element löschen": "Element entfernen",
  "Element wurde in die Zwischenablage kopiert": "Element wurde in die Zwischenablage kopiert.",
  "Elemente löschen": "Elemente entfernen",
  "Ende Icon": "Ende Icon",
  "Entfernen": "Entfernen",
  "Error": "Fehler",
  "Etwas ist schief gelaufen.": "Etwas ist schief gelaufen.",
  "Events": "Veranstaltungen",
  "Export im geteilten Plan ermöglichen": "Export im geteilten Plan ermöglichen",
  "Export Optionen": "Export Optionen",
  "export_kml_description": "Laden Sie Ihren Plan als KML herunter, um ihn in anderen Tools zu nutzen.\n\n<italic>Beachten Sie bitte, dass sich die Darstellung des Plans im KML von mapset unterscheiden kann.</italic>",
  "export_type_image": "Bild",
  "export_type_kml": "KML",
  "export_type_pdf": "PDF",
  "export_width_too_small_message": "Die zu exportierende Fläche ist zu klein. Bitte vergrössern Sie die Rahmenbreite auf {{width}} Pixel, um alle Elemente in der Vorlage richtig anzuzeigen.",
  "Exportieren": "Exportieren",
  "Externe kommerzielle Einrichtungen": "Externe kommerzielle Einrichtungen",
  "Fallend": "Fallend",
  "Farbe ändern": "Farbe ändern",
  "feature_styler_title_area": "Flächen-Einstellungen",
  "feature_styler_title_icon": "Icon-Einstellungen",
  "feature_styler_title_icon_group": "Piktogramm-Gruppen-Einstellungen",
  "feature_styler_title_label": "Text-Einstellungen",
  "feature_styler_title_line": "Linien-Einstellungen",
  "feature_styler_title_picture": "Bild-Einstellungen",
  "feature_styler_title_unknown": "Stileditor",
  "feature_type_area": "Fläche",
  "feature_type_icon": "Piktogramm",
  "feature_type_icon_group": "Piktogramm-Gruppe",
  "feature_type_label": "Beschriftung",
  "feature_type_line": "Linie",
  "feature_type_picture": "Bild",
  "feature_type_unknown": "Element",
  "feedback_form_error": "Ihre Nachricht konnte leider nicht gesendet werden. Wir versuchen, das Problem so schnell wie möglich zu beheben.",
  "feedback_form_file_helper_text": "Akzeptierte Formate: {{formats}}",
  "feedback_form_success": "Vielen Dank für Ihr Feedback. Wir werden Ihnen schnellstmöglich Rückmeldung geben.",
  "feedback_form_text": "Sie haben einen Fehler in mapset gefunden oder haben einen Verbesserungsvorschlag? Melden Sie ihn uns mit diesem Formular.\n\n Fehler in der Kartengrundlage dokumentieren Sie am besten direkt in mapset, indem Sie die korrekte Situation auf der Karte einzeichnen. Ihre Zeichnung wird automatisch als Link mitgeschickt. Alternativ können Sie ein eigenes Bild anhängen.",
  "Ferry": "Fähre",
  "ferry": "Fähre",
  "File size too big": "Dateigröße zu groß, max. {{size}}MB.",
  "Fläche zeichnen": "Polygon zeichnen",
  "Flächenfarbe": "Flächenfarbe",
  "foot": "Fussgänger",
  "form_attachment": "Anhang",
  "form_message": "Nachricht",
  "form_title": "Betreff",
  "Format": "Format",
  "Fortschritt gespeichert": "Fortschritt gespeichert",
  "Fortschritt speichern": "Speichern",
  "Fortschritt wird gespeichert": "Fortschritt wird gespeichert",
  "Funicular": "Standseilbahn",
  "funicular": "Standseilbahn",
  "Für den Export von PDF-Layouts müssen Sie eingeloggt sein.": "Für den Export von PDF-Layouts müssen Sie eingeloggt sein.",
  "Fussgänger": "Fussgänger",
  "fusswege": "Fusswege",
  "Ganzer Plan": "Ganzer Plan",
  "gebirgsnamen": "Gebirgsnamen",
  "gewässerlabel": "Gewässernamen",
  "Gondola": "Gondel- oder Seilbahn",
  "gondola": "Gondel- oder Seilbahn",
  "gross": "gross",
  "Grösse": "Grösse",
  "Gruppierung aufheben": "Gruppierung aufheben",
  "guide.customlayout": "pdf-vorlage",
  "guide.downloadplan": "bildherunterladen",
  "guide.drawarea": "flächezeichnen",
  "guide.drawicon": "piktogrammzeichnen",
  "guide.drawlabel": "textzeichnen",
  "guide.drawline": "liniezeichnen",
  "guide.drawroute": "routezeichnen",
  "guide.feedback": "feedback",
  "guide.insertpicture": "bildeinfügen",
  "guide.layertoggler": "ebenen",
  "guide.newplan": "neuerplan",
  "guide.plandefault": "standard-pläne",
  "guide.plannamesandlist": "planbenennungundplanliste",
  "guide.plansaveconfirm": "speichernbestatigen",
  "guide.plansaving": "speichern",
  "guide.plansharing": "zeichnungteilen",
  "guide.settings": "einstellungen",
  "guide.tags": "plaene-mit-tags",
  "Halt entfernen": "Halt entfernen",
  "Halt hinzufügen": "Halt hinzufügen",
  "haltekanten": "Haltekanten",
  "Haltestelle": "Haltestelle",
  "Haltestelle suchen": "Haltestelle suchen",
  "haltestellen": "Haltestellen",
  "haltestellenschilder": "Haltestellen-Schilder",
  "Hide at next startup": "Beim nächsten Start ausblenden",
  "Hilfslinien": "Hilfslinien",
  "Hineinzoomen": "Hineinzoomen",
  "Hintergrundfarbe": "Hintergrundfarbe",
  "hoch": "hoch",
  "Hochladen": "Dateien auswählen",
  "hotkeys.featureDelete": "auch mit Entf oder Backspace",
  "hotkeys.featureFreehand": "Freihand-Zeichnen mit Shift + linker Maustaste",
  "hotkeys.featureGroup": "auch mit Ctrl + G",
  "hotkeys.featureIconMultiselect": "Mehrfachauswahl mit Ctrl + Klick auf Piktogramm",
  "hotkeys.featureUngroup": "auch mit Ctrl + Shift + G",
  "hotkeys.mapRotate": "Karte drehen mit Alt + Shift + Karte ziehen",
  "icone_trenord": "Trenord Piktogramme",
  "Icons": "Icons",
  "Icons suchen": "Icons suchen",
  "Ihre Änderungen konnten nicht gespeichert werden. Bitte kontrollieren Sie Ihre Internet-Verbindung und versuchen Sie es erneut.": "Ihre Änderungen konnten nicht gespeichert werden. Bitte kontrollieren Sie Ihre Internet-Verbindung und versuchen Sie es erneut.",
  "Impressum": "Impressum",
  "Individuell": "Individuell",
  "Information zur Reisekette 1": "Information zur Reisekette 1",
  "Information zur Reisekette 2": "Information zur Reisekette 2",
  "Inspect-Modus": "Inspect-Modus",
  "Interne kommerzielle Einrichtungen": "Interne kommerzielle Einrichtungen",
  "Jetzt loslegen": "Jetzt loslegen",
  "Kartenausrichtung zurücksetzen": "Kartenausrichtung zurücksetzen",
  "kein": "kein",
  "Kein Plan vorhanden. Bitte erstellen Sie zuerst einen Plan.": "Kein Plan vorhanden. Bitte erstellen Sie zuerst einen Plan.",
  "kein QR-Code": "kein QR-Code",
  "Keine Icons gefunden.": "Keine Icons gefunden.",
  "Keine Pläne verfügbar.": "Keine Pläne verfügbar.",
  "klein": "klein",
  "Konturbreite": "Konturbreite",
  "Konturfarbe": "Konturfarbe",
  "Konturtype": "Konturtyp",
  "Kopie": "Kopie",
  "Kopieren": "Kopieren",
  "Kopiertes Element wurde eingefügt": "Kopiertes Element wurde eingefügt.",
  "Kreis zeichnen": "Kreis zeichnen",
  "Kreuzweise": "Kreuzweise",
  "Laden...": "Laden...",
  "Lageplan": "Lageplan",
  "landscape": "Landschaft",
  "linee_trenord": "Trenord Linien",
  "Linie": "Linie",
  "Linie zeichnen": "Linie zeichnen",
  "Linienabschluss": "Linienabschluss",
  "Linienanfang": "Linienanfang",
  "Linienbreite": "Linienbreite",
  "Linientyp": "Linientyp",
  "Link kopiert!": "Link kopiert!",
  "Link zum Bearbeiten": "Link zum Bearbeiten",
  "Link zum Teilen": "Link zum Teilen",
  "mapset_layout_description": "Beschreibung",
  "mapset_layout_description_placeholder": "Plan<b>beschreibung</b> ...",
  "mapset_layout_title": "Titel",
  "mapset_layout_title_placeholder": "Titel ...",
  "Maximale Anzahl an Haltestellen erreicht": "Maximale Anzahl an Haltestellen erreicht",
  "Meine Vorlage": "Meine Vorlage",
  "Mit diesem Link können Sie den Plan jederzeit weiter bearbeiten. Um die jetzige Version zu behalten, speichern Sie bitte diesen Link und erstellen dann einen": "Mit diesem Link können Sie den Plan jederzeit weiter bearbeiten. Um die jetzige Version zu behalten, speichern Sie bitte diesen Link und erstellen dann einen",
  "Mit dieser Aktion wird der aktuelle Plan entfernt und ein neuer Plan gestartet. Wollen Sie wirklich einen neuen Plan erstellen?": "Mit dieser Aktion wird der aktuelle Plan entfernt und ein neuer Plan gestartet. Wollen Sie wirklich einen neuen Plan erstellen?",
  "mittel": "mittel",
  "mostUsed": "Meist benutzt",
  "Muster": "Muster",
  "Nach ganz oben verschieben": "In den Vordergrund bringen",
  "Nach ganz unten verschieben": "In den Hintergrund verschieben",
  "Nach Tags filtern...": "Nach Tags filtern...",
  "neuen Plan": "neuen Plan",
  "Neuen Plan anlegen": "Neuen Plan anlegen",
  "Neuen Tag erstellen": "Neuen Tag erstellen",
  "Neuer Plan": "Neuer Plan",
  "neutrino": "Karte neutral",
  "NewPlan": "Diese Aktion startet einen neuen Plan. Wollen Sie wirklich fortfahren?",
  "Next Tip": "Nächster Tipp",
  "none": "Andere",
  "Nordpfeil": "Nordpfeil",
  "normal": "normal",
  "Nur durch Hilfslinien oder Ankerpunkten angeordnete Piktogramme behalten die Ausrichtung und Reihenfolge bei.": "Nur durch Hilfslinien oder Ankerpunkten angeordnete Piktogramme behalten die Ausrichtung und Reihenfolge bei.",
  "Öffnen": "Öffnen",
  "Organisation": "Organisation",
  "Ort": "Ort",
  "Ort, Adresse, Haltestelle": "Ort, Adresse, Haltestelle",
  "ortslabel": "Ortsnamen",
  "Ortung im geteilten Plan ermöglichen": "Ortung im geteilten Plan ermöglichen",
  "pärke": "Grünflächen",
  "Pflichtfeld": "Pflichtfeld",
  "Piktogramm zeichnen": "Piktogramm zeichnen",
  "Piktogramm-Ankerpunkte": "Piktogramm-Ankerpunkte",
  "Piktogramme": "Piktogramme",
  "Piktogramme gruppieren": "Piktogramme gruppieren",
  "Piktogramme selektiert": "Piktogramme selektiert",
  "Piktogrammen": "Piktogrammen",
  "Plan bearbeiten": "Plan bearbeiten",
  "Plan benennen": "Plan benennen",
  "Plan duplizieren": "Plan duplizieren",
  "Plan entfernen": "Plan entfernen",
  "Plan exportieren": "Plan exportieren",
  "Plan löschen": "Plan löschen",
  "Plan speichern": "Plan speichern",
  "Plan teilen": "Plan teilen",
  "Plan überschreiben": "Plan überschreiben",
  "Plan wechseln": "Plan wechseln",
  "Planliste": "Planliste",
  "Planname": "Planname",
  "pois": "POIs",
  "portrait": "Porträt",
  "Previous Tip": "Vorheriger Tipp",
  "QR-Code": "QR-Code",
  "QR-Code herunterladen": "QR-Code herunterladen",
  "Quadrat zeichnen": "Quadrat zeichnen",
  "rail": "Zug",
  "Rauszoomen": "Rauszoomen",
  "Route kann für dieses Verkehrsmittel nicht berechnet werden!": "Route kann für dieses Verkehrsmittel nicht berechnet werden!",
  "Route kreieren": "Route kreieren",
  "Route wird berechnet...": "Route wird berechnet...",
  "Route zeichnen": "Route zeichnen",
  "Routen-Finder": "Routen-Finder",
  "Routenlänge": "Routenlänge",
  "saturated": "Netzkarte Saturiert",
  "SavePlanMessage": "Den bestehenden Plan können sie unter dem Namen <b>{{name}}</b> oder mit folgendem Link jederzeit weiter bearbeiten.",
  "schiffslinien": "Schiffslinien",
  "Schliessen": "Schliessen",
  "Schreibgeschützt fortfahren": "Schreibgeschützt fortfahren",
  "Schriftkontur": "Schriftkontur",
  "sehr hoch": "sehr hoch",
  "seilbahnen": "Seilbahnen",
  "Seite neu laden": "Seite neu laden",
  "selektieren": "{{plan}} selektieren",
  "Serviceeinrichtungen": "Serviceeinrichtungen",
  "Show tips at startup": "Tipps beim Starten anzeigen",
  "Sicherheitseinrichtungen": "Sicherheitseinrichtungen",
  "Sie haben": "Sie haben",
  "Sie müssen eingeloggt sein, um diese Funktion nutzen zu können.": "Sie müssen eingeloggt sein, um diese Funktion nutzen zu können.",
  "Sie müssen eingeloggt sein, um diese Funktion weiterhin nutzen zu können.": "Sie müssen eingeloggt sein, um diese Funktion weiterhin nutzen zu können.",
  "Sie sind zur Zeit nicht angemeldet. Melden Sie sich an um mit der Bearbeitung fortzufahren, oder erstellen Sie einen neuen Plan.": "Sie sind zur Zeit nicht angemeldet. Melden Sie sich an um mit der Bearbeitung fortzufahren, oder erstellen Sie einen neuen Plan.",
  "Sie werden von allen geOps-Diensten abgemeldet.": "Sie werden von allen geOps-Diensten abgemeldet.",
  "Snapping aktivieren": "Snapping aktivieren",
  "Speichern": "Speichern",
  "Sprache": "Sprache",
  "Standard": "Standard",
  "Standard plan ist bereit": "Sie können diesen Standardplan für einen bestimmten Zeitpunkt <a href='{{defaultsUrl}}' {{linkAttributes}}> online</a> einsehen oder ihn auch <a href='{{defaultPrintUrl}}' {{linkAttributes}}>als PDF herunterladen</a>.",
  "Standardplan öffnen": "Standardplan öffnen",
  "Standort": "Standort",
  "Stapelreihenfolge": "Stapelreihenfolge",
  "Start- und Endpunkte müssen unterschiedlich sein!": "Start- und Endpunkte müssen unterschiedlich sein!",
  "Steigend": "Steigend",
  "strassen": "Strassennamen",
  "Subway": "U-bahn",
  "subway": "U-bahn",
  "Suche nach Plänen": "Suche nach Plänen",
  "Suche nach Tags...": "Suche nach Tags...",
  "Sucheingabe löschen": "Sucheingabe löschen",
  "SwitchPlan": "Diese Aktion wechselt zu Plan <b>{{name}}</b>. Wollen Sie wirklich fortfahren?",
  "Tag hinzufügen": "Neuen Tag \"{{name}}\" erstellen",
  "tag_add_confirmation": "Neu erstellte Tags werden für andere Mitglieder Ihres Teams verfügbar. \n\n Sind Sie sicher, dass Sie den Tag \"{{name}}\" hinzufügen wollen?",
  "Tags": "Tags",
  "Text": "Text",
  "Text hier eingeben": "Text hier eingeben",
  "Text zeichnen": "Text zeichnen",
  "Textausrichtung": "Textausrichtung",
  "Textfarbe": "Textfarbe",
  "Tippen Sie, um neue Tags zu erstellen": "Tippen Sie, um neue Tags zu erstellen",
  "Tram": "Tram",
  "tram": "Tram",
  "tramlinien": "Tramlinien",
  "tunnelbeschriftungen": "Tunnelnamen",
  "ubahnlinien": "U-Bahnlinien",
  "Um alle Funktionen in mapset zu nutzen, benötigt ihre Organisation ein Abonnement für mapset. Wenden Sie sich dazu bitte an support@mapset.ch.": "Um alle Funktionen in mapset zu nutzen, benötigt ihre Organisation ein Abonnement für mapset. Wenden Sie sich dazu bitte an <a href='mailto:support@mapset.ch' {{linkAttributes}}>support@mapset.ch</a>.",
  "Unbenannter Plan": "Unbenannter Plan",
  "unterfuehrungen": "Unterführungen",
  "User abmelden": "{{user.email}} abmelden",
  "Validity overlaps with another constrained default plan": "Gültigkeit überschneidet sich mit einem anderen Standardplan zu dieser Station",
  "Verkehrsmittel": "Verkehrsmittel",
  "verkehrsmittel": "Verkehrsmittel",
  "Verwenden Sie diesen Link, um den Plan an andere Leute weiterzugeben oder in andere Anwendungen einzubinden.": "Verwenden Sie diesen Link, um den Plan an andere Leute weiterzugeben oder in andere Anwendungen einzubinden.",
  "Vollflächig": "Vollflächig",
  "Vorschau": "Vorschau",
  "Weiter": "Weiter",
  "Wenn Ihre Zeichnung fertig ist, klicken Sie auf das rote SBB-Icon, um die Zeichnung im SBB-Webkartenportal anzuzeigen und zu teilen.": "Wenn Ihre Zeichnung fertig ist, klicken Sie auf das rote SBB-Icon, um die Zeichnung im SBB-Webkartenportal anzuzeigen und zu teilen.",
  "Willkommen in mapset": "Willkommen in mapset",
  "Wollen Sie Ihren Plan überschreiben oder eine neue Version des Plans anlegen?": "Wollen Sie Ihren Plan überschreiben oder eine neue Version des Plans anlegen?",
  "Zeichnung in WKP anzeigen": "Zeichnung im Webkartenportal anzeigen",
  "Zeichnung speichern": "Zeichnung speichern",
  "Zeichnung teilen": "Zeichnung teilen",
  "Ziehen um die Reihenfolge zu ändern": "Ziehen um die Reihenfolge zu ändern",
  "Zoom-Höchstwert": "Zoom-Höchstwert",
  "Zoom-Tiefstwert": "Zoom-Tiefstwert",
  "Zoomstufen": "Zoomstufen",
  "Zug": "Zug",
  "Zurück": "Zurück",
  "Zurück zum Plan": "Zurück zum Plan",
  "Zurücksetzen": "Zurücksetzen",
  "Dein Zugang zu dieser Organisation ist deaktiviert. Bitte wende dich an deinen Admin.": "Dein Zugang zu dieser Organisation ist deaktiviert. Bitte wende dich an deinen Admin.",
  "Die Testphase deiner Organisation ist abgelaufen. Bitte wende dich an deinen Admin.": "Die Testphase deiner Organisation ist abgelaufen. Bitte wende dich an deinen Admin.",
  "Die Testphase deiner Organisation ist abgelaufen. Wähle einen Plan, um weiterzuarbeiten.": "Die Testphase deiner Organisation ist abgelaufen. Wähle einen Plan, um weiterzuarbeiten.",
  "Die Einrichtung einer Organisation ist bald verfügbar.": "Die Einrichtung einer Organisation ist bald verfügbar.",
  "Organisation einrichten": "Organisation einrichten",
  "Upgrade": "Upgrade"
}
